<template>
  <div id="app">
    <header-nav></header-nav>
    <router-view />
    <div style="
        text-align: center;
        line-height: 40px;
        display: flex;
        gap: 30px;
        padding-left: 30px;
        background: var(--bg-color);
        color: var(--color);
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
      ">
      <div>© 2025 {{ COMPANY_NAME }} 版权所有，并保留所有权利。</div>
      <div v-if="ADDRESS">公司地址：{{ ADDRESS }}</div>
      <div v-if="EMAIL">E-mail: {{ EMAIL }}</div>
      <a style="color: var(--color);" href="https://beian.miit.gov.cn/" target="_blank">ICP备案证书号: {{ ICP }}
        &nbsp;&nbsp;&nbsp;{{ JYXKZ ? `经营许可证编号:${JYXKZ}` : "" }}</a>
    </div>
  </div>
</template>

<script>
import headerNav from "@/components/header-nav.vue";
import TopBar from '@/components/TopBar.vue'
export default {
  name: "App",
  components: {
    headerNav, TopBar
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue